<div class="fdm-embed-code-generator">
    <textarea readonly [formControl]="embedCodeControl" class="fdm-embed-code-generator-output"></textarea>
    <div class="fdm-embed-code-generator-options-grid">
        <div>
            Width:
        </div>
        <div></div>
        <div>
            Height:
        </div>
        <div></div>
        <div>
            <input type="number" [formControl]="widthControl" required class="w-100" />
        </div>
        <div>
            <select [formControl]="widthUnitControl" class="w-100 h-100">
                <option>%</option>
                <option>px</option>
            </select>
        </div>
        <div>
            <input type="number" [formControl]="heightControl" required class="w-100" />
        </div>
        <div>
            <select [formControl]="heightUnitControl" class="w-100 h-100">
                <option>%</option>
                <option>px</option>
            </select>
        </div>
    </div>

    <div mat-dialog-actions class="align-content-right">
        <!-- Copy code -->
        <button mat-raised-button class="ml-1" color="primary" (click)="copyToClipboard()" id="save-settings">{{ 'GENERIC.COPY_CLIPBOARD' | translate }} </button>
        <!-- Done -->
        <button mat-raised-button class="ml-1" color="primary" (click)="done()">{{ 'GENERIC.DONE' | translate }} </button>
    </div>
</div>